<template>
<div class="box">
    <div class="search">
        <van-search class="searchinput" autofocus show-action shape="round" v-model="input" style="font-size: 28px;" placeholder="请输入商品名称..."></van-search>
        <!-- <input v-model="input" type="text" placeholder="请输入搜索内容"> -->
        <div class="searchbotton" @click="handleSearchResult(input)">搜索</div>
    </div>
    <div class="history">
        <div class="search-host">
            <span>搜索历史:</span>
            <img src="../../../assets/icon/delate.png" name="delete" @click="clearHistory" />
            <!-- <span class="cancel" @click="clearHistory">清空</span> -->

        </div>
        <div class="tag">
            <div class="norecord" v-if="historyList.length == 0">暂时没有搜索记录</div>
            <van-tag class="vantag" v-else v-for="(historyItem, index) in historyList" :key="index" @click="searchTsOld(historyItem)">
                {{historyItem}}
            </van-tag>
        </div>
    </div>

</div>
</template>

<script>
import {
    queryRestPorduct
} from "../../../api/api";
export default {
    name: 'app',
    data() {
        return {
            input: '',
            historyList: []
        }
    },
    mounted() {
        if (this.$cookies.get('localHistory') !== null) {
            this.historyList = this.$cookies.get('localHistory').split('|')
        }
    },
    methods: {
        /**
         * 执行搜索
         */
        handleSearchResult(val) {
            if (val === '') {
                this.$toast("请输入搜索关键词~");
                return
            }
            this.$router.push({
                path: '/productList',
                query: {
                    cName: this.input,

                }
            })
            this.setlocalHistory(val) // 将搜索值加入本地localStorage
            this.historyList = this.$cookies.get('localHistory').split('|') // 从本地localStorage取出搜索历史并展示
            this.input = '' // 清空输入框
            // alert(`跳转至 ${val} 搜索结果页`) // 跳转至搜索结果页
        },
        /**
         * 加入历史搜索记录
         */
        setlocalHistory(val) {
            val = val.trim()
            let localHistory = this.$cookies.get('localHistory')
            if (localHistory === null) {
                this.$cookies.set('localHistory', val) // 若未设置过则直接设置本地存储
            } else {
                let localHistoryArray = localHistory.split('|').filter(item => item != val) // 删除搜索历史中与本次输出重复项
                if (localHistoryArray.length > 0) {
                    localHistory = val + '|' + localHistoryArray.join('|') // 新增记录
                }
                if (localHistory.split('|').length > 10) { // 最大历史搜索记录10条
                    localHistoryArray = localHistory.split('|')
                    localHistoryArray.pop() // 删除最旧一项
                    localHistory = localHistoryArray.join('|')
                }
                this.$cookies.set('localHistory', localHistory) // 存入本地
            }
        },
        /**
         * 清空历史搜索记录
         */
        clearHistory() {
            // debugger
            if (this.historyList.length == 0) {
                // debugger
                this.$toast("搜索记录已经为空~");
                return
            }
            this.$dialog.confirm({
                    message: '确定要清空搜索记录吗？',
                })
                .then(() => {
                    this.historyList = []
                    // localStorage.historyList = JSON.stringify(this.historyList)
                    this.$toast("清除成功！");
                })
                .catch(() => {
                    // on cancel
                    this.$toast("清除失败，请再次尝试~");
                });
            this.$cookies.remove('localHistory') // 清空搜索历史
        },
        searchTsOld(historyItem) {
            this.input = historyItem;
        }
    }
}
</script>

<style lang="scss" scoped>
.box {
    width: 100%;
    height: 100%;
    background-color: #FFFFFF;

    .search {
        padding: 50px 0 20px;
        position: relative;
        width: 95%;
        // height: 68px;
        margin: 0 auto;

        .van-search {
            border-radius: 34px;
            border: 2px solid #999999;
            padding: 0 20px;
        }

        .searchbotton {
            position: absolute;
            top: 59px;
            right: 110px;
            width: 120px;
            height: 54px;
            background: #1e53a4;
            border-radius: 32px;
            line-height: 54px;
            color: #fff;
            text-align: center;
            font-size: 28px;
        }
    }

    .history {
        padding: 0 30px;

        .hosttag {
            span {
                display: block;
                font-size: 28px;
                color: #333;
                padding-top: 25px;
            }
        }

        .search-host {
            span {
                display: block;
                font-size: 28px;
                color: #666666;

            }

            img {
                width: 38px;
                height: 38px;
            }
        }

        .tag {
            padding-top: 20px;

            .norecord {
                text-align: center;
                display: block;
                font-size: 26px;
            }

            .vantag {
                padding: 5px 10px;
                border: 2px solid #999999;
                background-color: #fff;
                border-radius: 8px;
                color: #999999;
                margin-right: 25px;
                margin-bottom: 25px;
            }
        }

        .serchimg {
            width: 100%;
            height: 50px;
            line-height: 50px;
            padding: 25px;

            img {
                width: 26px;
                height: 26px;
                padding-right: 10px;
            }

            span {
                font-size: 28px;
                color: #666666;
            }
        }
    }

    .search-host {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 5px;
        box-sizing: border-box;
    }

    .van-tag--default {
        padding: 18px 18px 18px 0;
    }

    .van-search__content {
        background: transparent;
        padding-left: 0;
    }

    .van-hairline--top-bottom {
        display: flex;
        padding: 18px 25px;
    }

}

/deep/.van-field__control {
    width: 80%;
}
</style>
